'use client';

import Error404Page from 'src/components/Shared/Error404Page';

export default function NotFound() {
  return <Error404Page />;
}
